import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  getScheduleByDay: ['startDate', 'period', 'enabledExams'],
  // Reducer
  getScheduleByDayRequest: null,
  getScheduleByDaySuccess: null,
  getScheduleByDayFailure: ['error'],
  getScheduleByDayClear: null
});

export { Creators, Types };
